import {I18n} from 'aws-amplify/utils';
import {
    Select,
    Stack,
} from '@mantine/core';
import {useFormikContext} from 'formik';

import {
    DELEGATION_OPTIONS,
    PROVIDER_OPTIONS,
    ZonesFilterFormValues,
} from './filterOptions';

export const FilterFormComponent = () => {

    const {
        values,
        setFieldValue,
    } = useFormikContext<ZonesFilterFormValues>();

    return (
        <Stack gap={'md'}>
            <Select
                label={I18n.get('Provider')}
                placeholder={I18n.get('Any provider')}
                data={PROVIDER_OPTIONS.map(option => ({
                    value: option.value,
                    label: I18n.get(option.label),
                }))}
                value={values.provider || null}
                onChange={value => setFieldValue('provider', value ?? '')}
                clearable={true}
            />

            <Select
                label={I18n.get('Delegation')}
                placeholder={I18n.get('Any delegation state')}
                // Said out loud in the form itself, because the distinction is
                // the whole reason this filter has three options.
                description={I18n.get('Not determined is its own state — it does not mean the zone is undelegated.')}
                data={DELEGATION_OPTIONS.map(option => ({
                    value: option.value,
                    label: I18n.get(option.label),
                }))}
                value={values.delegation || null}
                onChange={value => setFieldValue('delegation', value ?? '')}
                clearable={true}
            />
        </Stack>
    );
};
